/* eslint-disable */
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Card } from 'reactstrap';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { format } from 'date-fns';
import { map, findIndex, get } from 'lodash';
import NotificationSystem from 'react-notification-system';

import Select from 'components/Form/Select';
import Header from 'components/Header';
import LargeDataTable from 'components/Tables/LargeDataTable';
import { Grid, Column } from 'components/Layout';

import { getApplications, getDepositRefunds } from 'actions/application';
import { appConfig } from 'config/appConfig';
import { formatCurrency } from 'utils/formatCurrency';

import style from './style.scss';

const initialFilter = {
  refundId: '',
  createdOn: '',
  applicationId: '',
  applicantName: '',
  amountFinanced: '',
  refundRequestedAmount: '',
  depositId: '',
  finalRefundAmount: '',
  newAmountFinanced: '',
  refundStatusLabel: '',
  refundCompletedOn: '',
  merchant: '',
  assignedId: '',
  query: '',
  offset: 0,
  limit: appConfig.limit,
};

const depositInitialFilter = {
  depositId: '',
  transactionDate: '',
  transactionAmount: '',
  remainingTransactionAmount: '',
  depositStatusLabel: '',
  merchant: '',
  assignedId: '',
  query: '',
  offset: 0,
  limit: appConfig.limit,
};

const refundFilters = [
  { value: 'All', title: 'All' },
  { value: 'Requested', title: 'Requested' },
  { value: 'Dispute', title: 'Dispute' },
  { value: 'Review', title: 'Review' },
  { value: 'Info Required', title: 'Info Required' },
  { value: 'Approved', title: 'Approved' },
  { value: 'Declined', title: 'Declined' },
  { value: 'Withdrawn', title: 'Withdrawn' },
  { value: 'Sent for Refund', title: 'Sent for Refund' },
  { value: 'Completed', title: 'Completed' },
];

const depositFilters = [
  { value: 'All', title: 'All' },
  { value: 'Received', title: 'Received' },
  { value: 'Applied', title: 'Applied' },
  { value: 'Completed', title: 'Completed' },
];

const refundColumns = [
  { name: 'refundId', title: 'Refund ID', type: 'text', valueType: 'number', width: 150 },
  { name: 'createdOn', title: 'Requested', width: 150 },
  { name: 'applicationId', title: 'Application ID', type: 'text', width: 150, valueType: 'number' },
  { name: 'applicantName', title: 'Applicant', type: 'text', valueType: 'text', width: 150 },
  { name: 'amountFinanced', title: 'Current Amt Financed', width: 150, valueType: 'text' },
  { name: 'refundRequestedAmount', title: 'Return Amt', width: 150, valueType: 'text' },
  { name: 'depositId', title: 'Deposit ID', type: 'text', width: 150, valueType: 'number' },
  { name: 'finalRefundAmount', title: 'Final Refund Amt', width: 150, valueType: 'text' },
  { name: 'newAmountFinanced', title: 'New Amnt Financed', width: 150, valueType: 'text' },
  { name: 'refundStatusLabel', title: 'Refund Status', type: 'status', width: 180, valueType: 'text' },
  { name: 'refundCompletedOn', title: 'Refund Completed Date', width: 150 },
];

const depositColumns = [
  { name: 'depositId', title: 'Deposit ID', type: 'text', valueType: 'number', width: 120 },
  { name: 'transactionDate', title: 'Transaction Date' },
  { name: 'transactionAmount', title: 'Transaction Amount', valueType: 'text' },
  { name: 'remainingTransactionAmount', title: 'Remaining Transaction Amount', valueType: 'text' },
  { name: 'depositStatusLabel', title: 'Deposit Status', type: 'text', valueType: 'text' },
];

const initialQuery = {
  sortBy: 'CreatedOn',
  sortOrder: 'desc',
};

const FreshStart = (props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [depositLoading, setDepositLoading] = useState(true);
  const [rowCount, setRowCount] = useState(1);
  const [depositRowCount, setDepositRowCount] = useState(1);
  const [rows, setRows] = useState([]);
  const [depositRows, setDepositRows] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [searchValue, setSearchValue] = useState(props.match.params.searchQuery);
  const [filterObj, setFilterObj] = useState({
    refundId: '',
    createdOn: '',
    applicationId: '',
    applicantName: '',
    amountFinanced: '',
    refundRequestedAmount: '',
    depositId: '',
    finalRefundAmount: '',
    newAmountFinanced: '',
    refundStatusLabel: '',
    refundCompletedOn: '',
    merchant: '',
    assignedId: '',
    query: '',
    offset: 0,
    limit: appConfig.limit,
  });
  const [depositFilterObj, setDepositFilterObj] = useState({
    depositId: '',
    transactionDate: '',
    transactionAmount: '',
    remainingTransactionAmount: '',
    depositStatusLabel: '',
    merchant: '',
    assignedId: '',
    query: '',
    offset: 0,
    limit: appConfig.limit,
  });
  const [query, setQuery] = useState(initialQuery);
  const [depositQuery, setDepositQuery] = useState(initialQuery);
  const [activeTab, setActiveTab] = useState('1');
  const filters = JSON.parse(localStorage.getItem('filters'));
  const notificationSystem = useRef(null);

  useEffect(() => {
    const { statusCode } = props.match.params;
    const selectedValueIndex = findIndex(get(filters, '0.filters'), item => item.name === statusCode);
    setSelectedValue(JSON.stringify(get(get(filters, '0.filters'), `${selectedValueIndex}`)));
  }, []);

  const getParameter = (selectedValueArg, filterObjArg, searchValue, queryArg = {}) => {
    const newQuery = { ...queryArg };
    if (selectedValueArg && selectedValueArg !== 'All') {
      newQuery[activeTab === '1' ? 'refundStatus' : 'depositStatus'] = selectedValueArg;
    }

    const urlEncode = (obj) => {
      Object.keys(obj).forEach((key) => {
        const str = (typeof obj[key] === 'object') ? JSON.stringify(obj[key]) : obj[key];
        // eslint-disable-next-line no-param-reassign
        obj[key] = encodeURIComponent(str);
      });
      return obj;
    };
    const ret = {
      filterObj: filterObjArg,
      search: searchValue,
      query: urlEncode(newQuery),
    };
    return ret;
  };

  const getAllApplications = ({
    filterObjArg = initialFilter,
    query = { sortBy: 'CreatedOn', sortOrder: 'desc' },
  }) => {
    const filtersTemp = [];

    filtersTemp[0] = (filterObjArg.refundId !== '') ? `refundId=${filterObjArg.refundId}&` : '';
    filtersTemp[1] = (filterObjArg.applicationId !== '') ? `applicationId=${filterObjArg.applicationId}&` : '';
    filtersTemp[2] = (filterObjArg.applicantName !== '') ? `applicantName=${filterObjArg.applicantName}&` : '';
    filtersTemp[3] = (filterObjArg.depositId !== '') ? `depositId=${filterObjArg.depositId}&` : '';
    filtersTemp[4] = (filterObjArg.refundStatus !== '') ? `refundStatus.label=${filterObjArg.refundStatus}&` : '';
    filtersTemp[5] = localStorage.getItem('merchantId') ? `merchantId=${localStorage.getItem('merchantId')}&` : `merchantId=${null}&`;
    filtersTemp[6] = query !== '' ? `${map(query, (value, key) => `${key}=${value}`).join('&')}&` : '';

    const url =
      `/refunds/search?${
        filtersTemp.join('')
      }&offset=${
        filterObjArg.offset
      }&limit=${
        filterObjArg.limit
      }`;
    setLoading(true);
    dispatch(getApplications({
      url,
      success: (res) => {
        const rowsTemp = res.data.map((item) => {
          const {
            refundId,
            createdOn,
            applicationId,
            applicantName,
            amountFinanced,
            refundRequestedAmount,
            depositId,
            finalRefundAmount,
            newAmountFinanced,
            refundStatus,
            refundCompletedOn,
          } = item;

          return {
            refundId,
            createdOn: createdOn ? format(new Date(createdOn), 'MM-dd-yyyy') : '-',
            applicationId,
            applicantName,
            amountFinanced: amountFinanced && parseFloat(amountFinanced) > 0 ? `$ ${formatCurrency(amountFinanced, 2)}` : '-',
            refundRequestedAmount: refundRequestedAmount && parseFloat(refundRequestedAmount) > 0 ? `$ ${formatCurrency(refundRequestedAmount, 2)}` : '-',
            depositId,
            finalRefundAmount: finalRefundAmount && parseFloat(finalRefundAmount) > 0 ? `$ ${formatCurrency(finalRefundAmount, 2)}` : '-',
            newAmountFinanced: newAmountFinanced && parseFloat(newAmountFinanced) > 0 ? `$ ${formatCurrency(newAmountFinanced, 2)}` : '-',
            refundStatusLabel: refundStatus ? refundStatus.label : '',
            statusCode: refundStatus ? refundStatus.code : '',
            statusLabel: refundStatus ? refundStatus.label : '',
            refundCompletedOn: refundCompletedOn ? format(new Date(refundCompletedOn), 'MM-dd-yyyy') : '-',
            item,
          };
        });

        setRows(filterObjArg.offset > 0 ? [...rows, ...rowsTemp] : rowsTemp);
        setRowCount(res.pagination.total);
        setLoading(false);
      },
      fail: (err) => {
        setLoading(false);

        if (err.data) {
          notificationSystem.current
          && notificationSystem.current.addNotification({
            message: err.data.message,
            level: 'error',
            position: 'tc',
          });
        } else {
          console.log('Error', err);
        }
      },
    }));
  }

  const getDepositApplications = ({
    filterObjArg = depositInitialFilter,
    query = { sortBy: 'CreatedOn', sortOrder: 'desc' },
  }) => {
    const filtersTemp = [];
    filtersTemp[0] = (filterObjArg.depositId !== '') ? `depositId=${filterObjArg.depositId}&` : '';
    filtersTemp[1] = (filterObjArg.depositStatusLabel !== '') ? `depositStatus=${filterObjArg.depositStatusLabel}&` : '';
    filtersTemp[2] = localStorage.getItem('merchantId') ? `merchantId=${localStorage.getItem('merchantId')}&` : `merchantId=${null}&`;
    filtersTemp[3] = query !== '' ? `${map(query, (value, key) => `${key}=${value}`).join('&')}&` : '';

    const url =
      `/refunds/deposits?${
        filtersTemp.join('')
      }&offset=${
        filterObjArg.offset
      }&limit=${
        filterObjArg.limit
      }`;
    setDepositLoading(true);
    dispatch(getApplications({
      url,
      success: (res) => {
        const depositRowsTemp = res.data.map((item) => {
          const {
            depositId,
            transactionDate,
            transactionAmount,
            remainingTransactionAmount,
            status,
          } = item;

          return {
            depositId,
            transactionDate: transactionDate ? format(new Date(transactionDate), 'MM-dd-yyyy') : '-',
            transactionAmount: transactionAmount && parseFloat(transactionAmount) > 0 ? `$ ${formatCurrency(transactionAmount, 2)}` : '$ 0.00',
            remainingTransactionAmount: remainingTransactionAmount && parseFloat(remainingTransactionAmount) > 0 ? `$ ${formatCurrency(remainingTransactionAmount, 2)}` : '$ 0.00',
            depositStatusLabel: status,
            item,
            isExpand: true,
            detailInfo: [],
          };
        });

        setDepositRows(filterObjArg.offset > 0 ? [...depositRows, ...depositRowsTemp] : depositRowsTemp);
        setDepositRowCount(res.pagination.total);
        setDepositLoading(false);
      },
      fail: (err) => {
        setDepositLoading(false);

        if (err.data) {
          notificationSystem.current
          && notificationSystem.current.addNotification({
            message: err.data.message,
            level: 'error',
            position: 'tc',
          });
        } else {
          console.log('Error', err);
        }
      },
    }));
  };

  const setNewActiveTab = (tabIndex) => {
    if (tabIndex !== activeTab) {
      setActiveTab(tabIndex);
    }
  };

  const filterHandler = (queries) => {
    const filterObjTemp = {
      refundId: queries.keys[0].data,
      applicationId: queries.keys[2].data,
      applicantName: queries.keys[3].data,
      depositId: queries.keys[6].data,
      refundStatus: queries.keys[9].data,
      offset: queries.pageOffset,
      limit: queries.pageLength,
    };
    const { sorting } = queries;
    query.sortBy = sorting.columnName;
    query.sortOrder = sorting.direction;

    const param = getParameter(selectedValue, filterObjTemp, searchValue, query);
    getAllApplications(param);
    setFilterObj(filterObjTemp);
  };

  const depositFilterHandler = (queries) => {
    const depositFilterObjTemp = {
      depositId: queries.keys[0].data,
      depositStatusLabel: queries.keys[4].data,
      offset: queries.pageOffset,
      limit: queries.pageLength,
    };
    const { sorting } = queries;
    depositQuery.sortBy = sorting.columnName;
    depositQuery.sortOrder = sorting.direction;

    const param = getParameter(selectedValue, depositFilterObjTemp, searchValue, depositQuery);
    getDepositApplications(param);
    setDepositFilterObj(depositFilterObjTemp)
  };

  const handleFilterChange = (e) => {
    const selectedValueTemp = e.target.value;

    if (activeTab === '1') {
      const filterObjTemp = {
        ...filterObj,
        offset: 0,
      };
      setFilterObj(filterObjTemp);
      setSelectedValue(selectedValueTemp);
      const param = getParameter(selectedValueTemp, filterObjTemp, searchValue, { sortBy: 'applicationDate', sortOrder: 'asc' });
      getAllApplications(param);
    } else {
      const depositFilterObjTemp = {
        ...depositFilterObj,
        offset: 0,
      };
      setDepositFilterObj(depositFilterObjTemp);
      setSelectedValue(selectedValueTemp);
      const param = getParameter(selectedValueTemp, depositFilterObjTemp, searchValue, { sortBy: 'applicationDate', sortOrder: 'asc' });
      getDepositApplications(param);
    }
  };

  const renderDetail = (row) => {
    const detail = row ? row.detailInfo : null;

    return (
      <div style={{ padding: 12 }}>
        <table>
          <thead>
            <tr>
              <th>Refund ID</th>
              <th>Application ID</th>
              <th>Return Amount</th>
              <th>Refund Status</th>
            </tr>
          </thead>
          <tbody>
            {detail && detail.length ? detail.map(item => (
              <tr>
                <td>{item.refundId}</td>
                <td>{item.applicationId}</td>
                <td>{formatCurrency(item.refundRequestedAmount)}</td>
                <td>{item.refundStatus.label}</td>
              </tr>
            )) : (
              <tr>
                <td colSpan="4" style={{ textAlign: 'center' }}>No Data</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    )
  };

  const handleChangeExpandedDetails = (expandedRowIds) => {
    expandedRowIds.forEach(id => {
      if (depositRows[id].detailInfo.length === 0) {
        setDepositLoading(true);
        dispatch(getDepositRefunds({
          url: `/refunds/search?depositId=${depositRows[id].depositId}`,
          success: (res) => {
            depositRows[id].detailInfo = res.data;
            setDepositRows(depositRows.map(_ => _));
            setDepositLoading(false);
          },
          fail: (err) => {
            if (err.response && err.response.data) {
              notificationSystem.current
              && notificationSystem.current.addNotification({
                message: err.response.data.message,
                level: 'error',
                position: 'tc',
              });
            } else {
              console.log('Error', err);
            }
          },
        }));
      }
    });
  }

  return (
    <Fragment>
      <Header />
      <NotificationSystem ref={notificationSystem} />
      <section className="container section">
        <div className="grid-container fluid portal freshstart page-applications">
          <Grid>
            <Column className="small-12 card-grid-container">

              <Grid className={cn('grid-margin-x page-header no-border', style.noTopMargin)}>
                <Column className="small-12 large-9">
                  <h3>Return of Funds Review</h3>
                </Column>
                <Column className="small-12 large-3">
                  <Select
                    name="form-field-name"
                    value={selectedValue}
                    onChange={handleFilterChange}
                    placeHolder="All Applications"
                    data={activeTab === '1' ? refundFilters : depositFilters}
                    hasDefault={false}
                    isErrorVisible={false}
                  />
                </Column>
              </Grid>

              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={cn({ active: activeTab === '1' })}
                    onClick={() => { setNewActiveTab('1'); }}
                  >
                    Returns
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={cn({ active: activeTab === '2' })}
                    onClick={() => { setNewActiveTab('2'); }}
                  >
                    Deposits
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                  <Card style={{ overflow: 'visible' }}>
                    <LargeDataTable
                      key="filterTable_default"
                      className="grid-x card-table"
                      columns={refundColumns}
                      defaultSorting={[{ columnName: query.sortBy, direction: query.sortOrder }]}
                      pageOffset={{ offset: filterObj.offset, limit: filterObj.limit }}
                      hasGrouping
                      hasSorting
                      loading={loading}
                      rows={rows}
                      rowCount={rowCount}
                      onFilter={(queries, isInitial, isHeaderTag) => { filterHandler(queries, isInitial, isHeaderTag); }}
                      infiniteScroll
                      isRowClickable={false}
                    />
                  </Card>
                </TabPane>
                <TabPane tabId="2">
                  <Card style={{ overflow: 'visible' }}>
                    <LargeDataTable
                      className="grid-x card-table"
                      columns={depositColumns}
                      defaultSorting={[{ columnName: depositQuery.sortBy, direction: depositQuery.sortOrder }]}
                      pageOffset={{ offset: depositFilterObj.offset, limit: depositFilterObj.limit }}
                      hasGrouping
                      hasSorting
                      loading={depositLoading}
                      rows={depositRows}
                      rowCount={depositRowCount}
                      onFilter={(queries, isInitial, isHeaderTag) => { depositFilterHandler(queries, isInitial, isHeaderTag); }}
                      isRowClickable={false}
                      detailRender={renderDetail}
                      hasDetailRows
                      hasDetailRender
                      onChangeExpandedDetails={handleChangeExpandedDetails}
                      infiniteScroll
                    />
                  </Card>
                </TabPane>
              </TabContent>
            </Column>
          </Grid>
        </div>
      </section>
    </Fragment>
  );
};

FreshStart.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

export default withRouter(FreshStart);



// WEBPACK FOOTER //
// ./src/containers/pages/FreshStart/index.js